import React from "react";
import "./AcornPlanningPublishingTab.css";
import { TextWithLineBreaks } from "../../../Components/TextWithLineBreaks";
import RoundedBox from "../../../Components/RoundedBox/RoundedBox";
import RoundedBoxWithArrow from "../../../Components/RoundedBoxWithArrow/RoundedBoxWithArrow";
import ComparisonTable from "../../Shared/ComparisonTable/ComparisonTable";

function AcornPlanningPublishingTab() {
  const CustomRoundBoxStyle1 = {
    display: "flex",
    flexDirection: "column",
    gap: "10px",
    backgroundColor: "#248bff",
    color: "white",
    width: "350px",
    position: "relative",
  };

  const CustomRoundBoxStyle2 = {
    backgroundColor: "transparent",
    border: "1px solid #EFF2F9",
    width: "440px",
    height: "auto",
    padding: "20px",
    textAlign: "left",
  };

  return (
    <div className="acorn-planning-publishing-tab">
      <div className="acorn-planning-publishing-tab-title">
        기획 출판이란 무엇인가요?
      </div>

      <div className="acorn-planning-publishing-tab-desc">
        <TextWithLineBreaks
          text={
            "기획 출판은 출판사가 시장 분석을 바탕으로 도서를 기획하고,\n 적합한 저작자를 섭외하여 진행하는 출판 방식입니다. \n출판사가 모든 비용을 부담하고 전체 과정을 주도합니다."
          }
        />
      </div>

      <div className="acorn-planning-publishing-tab-spacer" />

      <div className="acorn-planning-publishing-tab-title">
        에이콘 기획 출판의 장점은 무엇인가요?
      </div>

      <div className="acorn-planning-publishing-tab-box-row">
        <RoundedBox style={CustomRoundBoxStyle1}>
          <div className="acorn-planning-publishing-tab-effect" />
          <div className="acorn-planning-publishing-tab-box-title">
            출판사 투자
          </div>
          <div className="acorn-planning-publishing-tab-box-desc">
            제작비 부담 없이 출판사가 출간 비용 부담
          </div>
        </RoundedBox>
        <RoundedBox style={CustomRoundBoxStyle1}>
          <div className="acorn-planning-publishing-tab-effect" />
          <div className="acorn-planning-publishing-tab-box-title">
            전문 기획
          </div>
          <div className="acorn-planning-publishing-tab-box-desc">
            출판사의 시장 분석 기반 기획
          </div>
        </RoundedBox>
        <RoundedBox style={CustomRoundBoxStyle1}>
          <div className="acorn-planning-publishing-tab-effect" />
          <div className="acorn-planning-publishing-tab-box-title">
            체계적 관리
          </div>
          <div className="acorn-planning-publishing-tab-box-desc">
            편집부터 마케팅까지 원스톱 서비스
          </div>
        </RoundedBox>
      </div>
      <div className="acorn-planning-publishing-tab-box-row">
        <RoundedBox style={CustomRoundBoxStyle1}>
          <div className="acorn-planning-publishing-tab-effect" />
          <div className="acorn-planning-publishing-tab-box-title">
            유통 네트워크
          </div>
          <div className="acorn-planning-publishing-tab-box-desc">
            출판사의 강력한 유통망 활용
          </div>
        </RoundedBox>
        <RoundedBox style={CustomRoundBoxStyle1}>
          <div className="acorn-planning-publishing-tab-effect" />
          <div className="acorn-planning-publishing-tab-box-title">
            브랜드 파워
          </div>
          <div className="acorn-planning-publishing-tab-box-desc">
            출판사 브랜드를 통한 신뢰도 확보
          </div>
        </RoundedBox>
      </div>

      <div className="acorn-planning-publishing-tab-spacer" />

      <div className="acorn-planning-publishing-tab-title">
        기획 출판, 이런 분들에게 추천합니다!
      </div>

      <div className="acorn-planning-publishing-tab-grid">
        <RoundedBox style={CustomRoundBoxStyle2}>
          전문성: 특정 분야의 전문 지식이나 경험 보유
        </RoundedBox>
        <RoundedBox style={CustomRoundBoxStyle2}>
          시장성: 대중적 관심과 판매 가능성이 높은 아이디어
        </RoundedBox>
        <RoundedBox style={CustomRoundBoxStyle2}>
          플랫폼: 블로그, SNS 등에서 높은 인지도와 영향력 보유
        </RoundedBox>
        <RoundedBox style={CustomRoundBoxStyle2}>
          콘텐츠: 방송, 강연 등 2차 콘텐츠로 확장 가능한 원고
        </RoundedBox>
        <RoundedBox style={CustomRoundBoxStyle2}>
          협업 능력: 출판사와 긴밀한 협업 및 피드백 수용 가능
        </RoundedBox>
      </div>

      <div className="acorn-planning-publishing-tab-dist">
        <div className="acorn-planning-publishing-tab-title">
          기획 출판, 무엇을 준비해야 하나요?
        </div>
        <div className="acorn-planning-publishing-tab-box-row-arrow">
          <RoundedBoxWithArrow label={"기존 작품이나 글쓰기 샘플 준비"}>
            <div className="acorn-planning-publishing-tab-box-title">
              포트폴리오
            </div>
          </RoundedBoxWithArrow>
          <RoundedBoxWithArrow label={"해당 분야 경력이나 자격 증명"}>
            <div className="acorn-planning-publishing-tab-box-title">
              전문성 입증
            </div>
          </RoundedBoxWithArrow>
          <RoundedBoxWithArrow label={"구체적인 도서 기획안 작성"}>
            <div className="acorn-planning-publishing-tab-box-title">
              아이디어 제안
            </div>
          </RoundedBoxWithArrow>
          <RoundedBoxWithArrow label={"블로그, SNS 등을 통한 인지도 구축"}>
            <div className="acorn-planning-publishing-tab-box-title">
              플랫폼 활동
            </div>
          </RoundedBoxWithArrow>
          <RoundedBoxWithArrow label={"출판업계 관련자들과의 인맥 형성"}>
            <div className="acorn-planning-publishing-tab-box-title">
              네트워킹
            </div>
          </RoundedBoxWithArrow>
        </div>
      </div>

      <ComparisonTable highlightedColumn="planned" />
      <div className="acorn-planning-publishing-tab-spacer" />
    </div>
  );
}

export default AcornPlanningPublishingTab;
